import styled from "@emotion/styled";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

const StyledEntrySkeleton = styled(Skeleton)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    borderRadius: theme.kaltura.shape.roundness2,
}));

export interface EntryListSkeletonProps {
    /**
     * Number of entry skeletons to render
     */
    count?: number;
}

/**
 * Reusable entry list skeleton component
 */
export function EntryListSkeleton({ count = 4 }: EntryListSkeletonProps) {
    return (
        <>
            {Array
                .from({ length: count })
                .map((_, index) => (
                    <StyledEntrySkeleton key={index} variant="rectangular" height={138} />
                ))}
        </>
    );
}
